import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const Title = styled.h4`
  color: ${colors.principalOrange};
  flex: 1;
  font-size: 2em;
  text-align: left;
  margin: ${props => props.margin}
`;

Title.defaultProps = {
  margin: '2rem 0'
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/common/Title.js